angular.module("vgresiduos").controller("SupplierViewCollectionRequestDisposalEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `fornecedor/gestao-solicitacoes/destinacao/${$stateParams.id}`);
		};
	}
]);
